import React from 'react';

// The reusable SVG Logo Component
export const TimestampGitLogo = ({noText=false, noDescription=false, ...props}) => {
  return (
    <svg
      viewBox="0 0 900 256"
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <style>{`
        /* Default to Light Mode */
        .timestamp-text { fill: #000000; }
        .logo-bg-fill { fill: #ffffff; }
        
        /* Dark Mode Preferences */
        @media (prefers-color-scheme: dark) {
          :root:not([data-mantine-color-scheme="light"]):not([data-theme="light"]) .timestamp-text {
            fill: #FFFFFF;
          }
          :root:not([data-mantine-color-scheme="light"]):not([data-theme="light"]) .logo-bg-fill {
            fill: #0B0D17;
          }
        }
        
        /* Explicit Mantine Data Attributes for Dark Mode */
        :root[data-mantine-color-scheme="dark"] .timestamp-text,
        :root[data-theme="dark"] .timestamp-text { 
          fill: #FFFFFF; 
        }
        :root[data-mantine-color-scheme="dark"] .logo-bg-fill,
        :root[data-theme="dark"] .logo-bg-fill { 
          fill: #0B0D17; 
        }
        
        /* Explicit Mantine Data Attributes for Light Mode */
        :root[data-mantine-color-scheme="light"] .timestamp-text,
        :root[data-theme="light"] .timestamp-text { 
          fill: #000000; 
        }
        :root[data-mantine-color-scheme="light"] .logo-bg-fill,
        :root[data-theme="light"] .logo-bg-fill { 
          fill: #ffffff; 
        }
        `}</style>
      <defs>
        {/* Teal/Blue Gradient for Code/Git */}
        <linearGradient id="gitGrad" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#339af0" /> {/* Mantine Blue 5 */}
          <stop offset="100%" stopColor="#20c997" /> {/* Mantine Teal 5 */}
        </linearGradient>

        {/* Orange/Gold Gradient for Bitcoin/Timestamp Anchor */}
        <linearGradient id="btcGrad" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#ff922b" /> {/* Mantine Orange 5 */}
          <stop offset="100%" stopColor="#fcc419" /> {/* Mantine Yellow 5 */}
        </linearGradient>

        {/* Soft Glow Effect for the Anchor */}
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="12" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>

      {/* === LOGO MARK (THE ICON) === */}
      {/* Translated slightly to the right to balance visual weight */}
      <g transform="translate(16, 0)">

        {/* 1. The Blockchain Hexagon (Background Shield) */}
        <polygon
          points="128,32 211.1,80 211.1,176 128,224 44.9,176 44.9,80"
          fill="none"
          stroke="url(#gitGrad)"
          strokeWidth="12"
          strokeLinejoin="round"
          opacity="0.25"
        />

        {/* 2. The Git Branch Structure */}
        {/* Main Vertical Commit Line */}
        <line
          x1="96" y1="80"
          x2="96" y2="176"
          stroke="url(#gitGrad)"
          strokeWidth="14"
          strokeLinecap="round"
        />

        {/* Branching Line (Curves from the bottom node to the right) */}
        <path
          d="M 96 156 Q 160 156 160 104"
          fill="none"
          stroke="url(#gitGrad)"
          strokeWidth="14"
          strokeLinecap="round"
        />

        {/* Standard Git Nodes (Hollow circles with thick borders) */}
        <circle cx="96" cy="80" r="14" fill="#0B0D17" stroke="url(#gitGrad)" strokeWidth="8" />
        <circle cx="96" cy="176" r="14" fill="#0B0D17" stroke="url(#gitGrad)" strokeWidth="8" />

        {/* 3. The Timestamp/Anchor Node (Gold) */}
        {/* Ambient Glow behind the anchor */}
        <circle cx="160" cy="104" r="24" fill="url(#btcGrad)" filter="url(#glow)" opacity="0.4" />

        {/* Solid Anchor Node */}
        <circle cx="160" cy="104" r="20" fill="url(#btcGrad)" />

        {/* Cryptographic Checkmark inside the Anchor (Dark contrast) */}
        <path
          d="M 150 104 L 156 110 L 170 96"
          fill="none"
          stroke="#0B0D17"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      {/* === LOGO WORDMARK (THE TEXT) === */}
      {/* Using standard system fonts for maximum compatibility and sleekness */}

      {!noText &&
          <text
            x="260" y="146"
            fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
            fontSize="80"
            fontWeight="800"
            letterSpacing="-2"
          >
            <tspan className="timestamp-text">Timestamp</tspan>
            <tspan fill="url(#gitGrad)"> GIT</tspan>
          </text>
        }

      {/* Tagline (Enterprise positioning) */}
    {!noDescription && !noText &&
      <text
        x="266" y="188"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        fontSize="16"
        fontWeight="700"
        fill="#909296"
        letterSpacing="5"
        >
        CRYPTOGRAPHIC PRIOR ART
      </text>
        }
    </svg>
  );
}

// A simple wrapper for the preview environment
export default function App() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0B0D17', // Mantine dark background equivalent
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{ width: '100%', maxWidth: '800px' }}>
        <TimestampGitLogo />
      </div>
    </div>
  );
}